import { showError } from "./ErrorPopup";
import React from "react";
import { FiTrash2 } from "react-icons/fi";
import { apiFetch } from '../utils/apiClient'; // ✅ import your reusable fetch hel

const Grouproleschema = ({ roles, groupName }) => {
  const handleDelete = async (userId, group) => {
    try {
      // Send DELETE request to backend using fetch
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/roles/${userId}?group=${group}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    
      const result = await response.json();

        if (!response.ok) {
        throw new Error(result.error || result.message);
      }
    } catch (error) {
      console.error(error);
      showError(error); // ou setError(error.message)
    }
  };

  return (
   <div className="mt-10">
  {/* Titre du groupe */}
  <h2 className="text-2xl font-bold text-gray-800 border-b-2 border-blue-500 inline-block pb-1 mb-6">
    👥 {groupName}
  </h2>

  {/* Liste des rôles */}
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {roles.map((role, index) => (
      <div
        key={`role-${index}`}
        className="relative bg-white rounded-xl shadow-md border border-gray-200 p-5 hover:shadow-xl transition"
      >
        {/* Bouton supprimer en haut à droite */}
        <button
          onClick={() => handleDelete(role.userId, role.group)}
          className="absolute top-3 right-3 text-gray-400 hover:text-red-600 transition"
        >
          <FiTrash2 size={18} />
        </button>

        {/* Infos utilisateur */}
        <div className="flex items-center space-x-3 mb-3">
          <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
            {role.nom?.charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-800">{role.nom}</p>
            <p className="text-xs text-gray-500">{role.email}</p>
          </div>
        </div>

        {/* Groupe tag */}
        <span className="inline-block px-3 py-1 text-xs font-medium bg-blue-50 text-blue-600 rounded-full">
          {role.group}
        </span>
      </div>
    ))}
  </div>
</div>
  );
};

export default Grouproleschema;
